import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import routeConstant from '../../../../lib/constants/routeConstant';
import { feedbackButtonStyles as styles } from './feedbackButton.style';
import FeedbackModal from '../../Modals/FeedbackModal/FeedbackModal';
import Button from "../../../shared/Button/Button";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

const FeedbackButton = () => {
    const location = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1023);
    const [isFullscreen, setIsFullscreen] = useState(!!document.fullscreenElement);

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 1024;
            setIsMobile(mobile);
            // If we switch to desktop, reset expanded state if needed
            if (!mobile) setIsExpanded(false);
        };

        const handleFullscreenChange = () => {
            setIsFullscreen(!!document.fullscreenElement || 
                           !!document.webkitFullscreenElement || 
                           !!document.mozFullScreenElement || 
                           !!document.msFullscreenElement);
        };

        window.addEventListener('resize', handleResize);
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.addEventListener('mozfullscreenchange', handleFullscreenChange);
        document.addEventListener('msfullscreenchange', handleFullscreenChange);

        return () => {
            window.removeEventListener('resize', handleResize);
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
            document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
            document.removeEventListener('msfullscreenchange', handleFullscreenChange);
        };
    }, []);

    // List of routes where the feedback button should NOT be shown
    const hideOnRoutes = [
        routeConstant.LOGIN_PAGE,
        routeConstant.SIGNUP_PAGE,
        routeConstant.SPORT_PAGE,
        routeConstant.FORGOT_PASSWORD_PAGE,
        routeConstant.VERIFY_OTP_PAGE,
        routeConstant.CREATE_PASSWORD_PAGE
    ];

    // Check if current path matches any of the hidden routes (using prefix matching for dynamic routes)
    const shouldHide = hideOnRoutes.some(route => location.pathname.startsWith(route));

    if (shouldHide) return null;

    const isLiveGamePage = location.pathname.startsWith(routeConstant.LIVE_GAME_PAGE);
    const shouldBeTopLeft = isLiveGamePage && isFullscreen;

    return (
        <>
            {isMobile ? (
                <div 
                    className={shouldBeTopLeft ? styles.mobileContainerTopLeft : styles.mobileContainer}
                    style={{ transform: isExpanded ? 'translateX(0)' : 'translateX(calc(-100% + 32px))' }}
                >
                    {/* Feedback Button (Mobile) */}
                    <button
                        className={styles.drawerButton}
                        onClick={() => setIsModalOpen(true)}
                    >
                        Have Feedback?
                    </button>
                    
                    {/* Drawer Handle / Arrow */}
                    <div 
                        className={styles.arrowHandle}
                        onClick={() => setIsExpanded(!isExpanded)}
                        aria-label={isExpanded ? "Hide Feedback" : "Show Feedback"}
                        title={isExpanded ? "Hide Feedback" : "Show Feedback"}
                    >
                        {isExpanded ? <ChevronLeftIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
                    </div>
                </div>
            ) : (
                <Button
                    variant="primaryOutline"
                    className={shouldBeTopLeft ? styles.buttonTopLeft : styles.button}
                    onClick={() => setIsModalOpen(true)}
                    aria-label="Have Feedback?"
                >
                    Have Feedback?
                </Button>
            )}

            <FeedbackModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </>
    );
};

export default FeedbackButton;
